import PropTypes from 'prop-types';

/** Structure of all Ticket PropType objects */
const Ticket = {};

const availabilityPropType = PropTypes.shape({
  type: PropTypes.number.isRequired, // ex: 1
  value: PropTypes.string.isRequired, // ex: Book Now
  typeDescriptor: PropTypes.string, // ex: available

  // TODO(ryan@): Document when these fields are used.
  from: PropTypes.string,
  fromFormatted: PropTypes.string,
  to: PropTypes.string,
  toFormatted: PropTypes.string,
});

/**
 * Summarizes information about all the tickets in the .tickets fields.
 * There will be a single summary for each individual race.
 */
Ticket.ticketsSummary = PropTypes.shape({
  // ==== Required ====
  available: PropTypes.bool.isRequired, // Are any tickets available?
  bookingEnabled: PropTypes.bool.isRequired, // Do any tickets have booking enabled?

  pricesFrom: PropTypes.number.isRequired, // Lowest ticket price available.
  discounts: PropTypes.bool.isRequired, // Do any tickets have discounts.
  currencyLabel: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,

  // ==== Optional ====
  pricesTo: PropTypes.number, // Highest ticket price available.

  // Array of tickets that are part of this summary.
  tickets: PropTypes.arrayOf(Ticket.singleTicket).isRequired,

  maxDiscount: PropTypes.shape({
    discountValue: PropTypes.string.isRequired,
  }),
});

Ticket.singleTicket = PropTypes.shape({
  // ==== Required ====
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  // TODO(ryan@): Sometimes this is returned with the availabilityType instead. Document why.
  availability: availabilityPropType.isRequired,

  bookingEnabled: PropTypes.bool.isRequired, // If the user is able to book on our site.
  bookingUrl: PropTypes.string.isRequired, // Url to organisers booking page.

  // Only one of the two fields below should be set.
  charityTickets: PropTypes.bool.isRequired, // Is Charity Ticket
  // Is Direct, Proxy, Integration, Tracking, or "Not Enabled"
  standardTickets: PropTypes.bool.isRequired,

  rrp: PropTypes.number.isRequired, // rrp = recommended retail price
  rrpFormatted: PropTypes.string.isRequired,

  currencyLabel: PropTypes.string.isRequired,

  // ==== Optional ====
  currencySybmol: PropTypes.string,

  discountPrice: PropTypes.number,
  discountPriceFormatted: PropTypes.string,
  discountCode: PropTypes.string,

  ballotTickets: PropTypes.bool, // DEPRECATED

  // TODO(ryan@): Confirm the shape of charity details.
  charityDetails: PropTypes.shape({}),

  bookingDetails: PropTypes.shape({
    // TODO(ryan@): Confirm if other fields present, and if price required.
    price: PropTypes.number,
  }),
});

Ticket.ticketForm = PropTypes.shape({
  id: PropTypes.string.isRequired,
  bookingEnabled: PropTypes.bool.isRequired,
  thirdPartyUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  event: PropTypes.shape({
    title: PropTypes.string.isRequired,
    images: PropTypes.shape({
      hero: PropTypes.shape({
        large: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    location: PropTypes.shape({
      addressSummary: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    }).isRequired,
    organiser: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      termsAndConditionsUrl: PropTypes.string,
    }),
  }).isRequired,
  price: PropTypes.shape({
    value: PropTypes.number.isRequired,
    originalValue: PropTypes.number.isRequired,
    valueFormatted: PropTypes.string.isRequired,
    originalValueFormatted: PropTypes.string.isRequired,
    currency: PropTypes.shape({
      code: PropTypes.string.isRequired,
      minorUnit: PropTypes.number.isRequired,
    }).isRequired,
    fee: PropTypes.number.isRequired,
    feeFormatted: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
    totalFormatted: PropTypes.string.isRequired,
  }).isRequired,
  race: PropTypes.shape({
    title: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
  }).isRequired,
});

export default Ticket;
